import { Switch } from "@headlessui/react";
import { classNames } from "../../utils/classNamesUtils";

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
}

export const FieldgistixSwitch: React.FC<SwitchProps> = ({ checked, onChange, label }) => {
  return (
    <label className="flex items-center cursor-pointer">
      <span className="mr-3 text-sm font-medium text-gray-900">{label}</span>
      <Switch
        checked={checked}
        onChange={onChange}
        className={classNames(
          checked ? "bg-indigo-500" : "bg-gray-200",
          "relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none"
        )}
      >
        <span
          className={classNames(
            checked ? "translate-x-6" : "translate-x-1",
            "inline-block h-4 w-4 transform bg-white rounded-full transition-transform duration-200 ease-in-out"
          )}
        />
      </Switch>
    </label>
  );
};
